import React, { useEffect, useState } from "react";
import { IconPatientJourney } from "../../../assets/icons/icon-patient-journey";
import { PhoneCall, PhoneMissed } from "lucide-react";
import CallHistory from "./call-history";
import { fetchCallLogs } from "../../../js/api/call-log";
import useMediaQuery from "../../common/custom-hooks/use-media-query";
import { IconCallLogNoData } from "../../../assets/icons/icon-call-log-no-data";

const CallLog = ({ trialInfo }) => {
  const [callData, setCallData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCallHistory = async () => {
      try {
        const response = await fetchCallLogs(trialInfo.patientTrialJuncID);
        setCallData(response.data.items);
      } catch (error) {
        console.error("Failed to fetch call history:", error);
      } finally {
        setLoading(false);
      }
    };

    if (trialInfo) {
      fetchCallHistory();
    }
  }, [trialInfo]);

  if (loading) {
    return (
      <div className="h-[50vh] flex justify-center items-center">
        <div className="mini-spinner"></div>
      </div>
    );
  }
  return (
    <div className="">
      {callData && callData.length === 0 && (
        <>
          <div className="text-center w-[100%] mb-5 flex justify-center">
            <IconCallLogNoData />
          </div>
          <p className="text-center w-[100%]">No call logs available for this patient</p>
        </>
      )}
      <div className="max-h-[55vh] overflow-y-auto pr-2">
        <CallHistory calls={callData} trialInfo={trialInfo} />
      </div>
    </div>
  );
};

export default CallLog;
